import {isArray, isObject} from 'util';
import {StandardFormMetaInfo} from './standard-form-meta-info.model';

export function planarizeTree(dataTree, meta: StandardFormMetaInfo[]) {
  if (!isArray(dataTree)) {
    return dataTree;
  }
  const result = [];
  dataTree.forEach(tree => {
    const raw = {};
    meta.forEach(info => {

      try {
        if ('value' in info) {
          raw[info.field] = info.value(tree);
        } else {
          raw[info.field] = tree[info.field];
        }
      } catch (e) {
        raw[info.field] = '';
      }
    });
    result.push(raw);
  });

  return result;
}

export function extractValue(obj, field, defaultValue = null) {
  if (!isObject(obj)) {
    return defaultValue;
  }

  if (!isArray(field)) {
    return extractValue(obj, [field], defaultValue);
  }

  if (field.length === 1) {
    return obj[field[0]];
  }

  return extractValue(obj[field[0]], field.slice(1), defaultValue);
}

// noinspection JSUnusedLocalSymbols
export function createObjectTree(rubrics, clearEmpty: boolean = false, existTree = {}) {
  const nth = (item, level = 0) => (item && item.objrubric) ? nth(item.objrubric, level + 1) : level;

  rubrics.sort((item1, item2) =>
    nth(item1) - nth(item2)
  );
  let res = [];
  rubrics.forEach(item => {
    if (!item.objrubric) {
      res.push({
        label: item.shortname,
        data: item,
        key: item.id,
        id: item.id,
        count: 0,
        statuses: {},
        childCount: 0,
        state: -1,
        isObject: false,
        selectable: true,
        styleClass: 'object-tree-node',
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
      });
    } else {
      const parent = findElement(res, item.objrubric.id);
      if (!parent) {
        res.push({
          label: item.shortname,
          data: item,
          key: item.id,
          id: item.id,
          count: 0,
          state: -1,
          statuses: {},
          isObject: false,
          selectable: true,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {
        if (!parent.children) {
          parent.children = [];
        }
        parent.children.push({
          label: item.shortname,
          key: item.id,
          data: item,
          count: 0, // количество дочерних параметров
          state: -1, //  максимальны статус дочернего параметра
          parent,
          statuses: {},  // статусы всех дочерних объектов
          childCount: 0, // общее количество дочерних объектов
          id: item.id,
          isObject: false,
          selectable: true,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      }
    }
  });

  if (clearEmpty) {
    res = clearEmptyRubrics(res);
  }
  return res;
}

export function createUnitExpandedTree(tree, selected, expanded: boolean) {
  if (selected) {
    selected.forEach(sel => {
      findUnitElementExpanded(tree, sel.id, expanded);
    });
  }
  return tree;
}

export function createPlaceExpandedTree(tree, selected, expanded: boolean) {
  if (selected) {
    selected.forEach(sel => {
      findPlaceElementExpanded(tree, sel.id, expanded);
    });
  }
  return tree;
}


export function createObjectOnlyExpandedTree(tree, selected, expanded: boolean) {
  if (selected) {
    selected.forEach(sel => {
      findObjectElementExpanded(tree, sel.id, expanded);
    });
  }
  return tree;
}

export function createObjectExpandedTree(tree, selected, expanded: boolean) {
  if (selected) {
    selected.forEach(sel => {
      findElementExpanded(tree, sel.id, expanded);
    });
  }
  return tree;
}

export function createObjectExpandedTreeByKey(tree, selected, expanded: boolean) {
  if (selected) {
    selected.forEach(sel => {
      findElementExpandedByKey(tree, sel.key, expanded);
    });
  }
  return tree;
}

export function clearEmptyRubrics(res) {
  res = res.filter(val => val.children || val.isDashboard);

  res = res.map(val => {
    if (val.children) {
      val.children = clearEmptyRubrics(val.children);
    }
    return val;
  });
  return res;
}

export function findElement(elements, id) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === id) {
      return elements[i];
    }
    if (elements[i].children) {
      const el = findElement(elements[i].children, id);
      if (el) {
        return el;
      }
    }
  }
}

export function searchItem(filtered, filter, isFound: boolean) {
  const cmp = filter?.toLowerCase() || '';
  return filtered.filter(val => {
    if (val.children) {
      const _isFound = val.label.toLowerCase().indexOf(cmp) !== -1;
      const filterItems = searchItem(val.children, filter, _isFound || isFound);
      val.children = filterItems;
      return filterItems.length > 0 || val.label.toLowerCase().indexOf(cmp) !== -1;
    } else if (val.isObject && val.parent) {
      return isFound;
    } else {
      return val.label.toLowerCase().indexOf(cmp) !== -1;
    }
  }).map(val => ({...val, expanded: true}));
}

export function searchItemExpanded(filtered, filter, isFound: boolean) {
  const cmp = filter.toLowerCase();
  return filtered.filter(val => {
    if (val.children) {
      const _isFound = val.label.toLowerCase().indexOf(cmp) !== -1;
      const filterItems = searchItemExpanded(val.children, filter, _isFound || isFound);
      val.children = filterItems;
      return filterItems.length > 0 || val.label.toLowerCase().indexOf(cmp) !== -1;
    } else if (val.isObject && val.parent && val.label) {
      return val.label.toLowerCase().indexOf(cmp) !== -1;
    } else {
      return val.label.toLowerCase().indexOf(cmp) !== -1;
    }
  }).map(val => ({...val, expanded: true}));
}

export function findElementExpandedByKey(elements, key, expanded: boolean) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].key === key) {
      return elements[i];
    }
    if (elements[i].children) {
      const el = findElementExpandedByKey(elements[i].children, key, expanded);
      if (el) {
        elements[i].partialSelected = true;
        if (expanded) {
          elements[i].expanded = true;
        }
        return el;
      }
    }
  }
}

export function findUnitElementExpanded(elements, id, expanded: boolean) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === id && elements[i].isDevice) {
      return elements[i];
    }
    if (elements[i].children) {
      const el = findUnitElementExpanded(elements[i].children, id, expanded);
      if (el) {
        elements[i].partialSelected = true;
        if (expanded) {
          elements[i].expanded = true;
        }
        return el;
      }
    }
  }
}

export function findPlaceElementExpanded(elements, id, expanded: boolean) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === id && elements[i].isPlace) {
      return elements[i];
    }
    if (elements[i].children) {
      const el = findPlaceElementExpanded(elements[i].children, id, expanded);
      if (el) {
        elements[i].partialSelected = true;
        if (expanded) {
          elements[i].expanded = true;
        }
        return el;
      }
    }
  }
}

export function findObjectElementExpanded(elements, id, expanded: boolean) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].children) {
      const el = findObjectElementExpanded(elements[i].children, id, expanded);
      if (el) {
        elements[i].partialSelected = true;
        if (expanded) {
          elements[i].expanded = true;
        }
        return el;
      }
    } else if (elements[i].id === id && elements[i].isObject) {
      return elements[i];
    }
  }
}

export function findElementExpanded(elements, id, expanded: boolean) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === id) {
      return elements[i];
    }
    if (elements[i].children) {
      const el = findElementExpanded(elements[i].children, id, expanded);
      if (el) {
        elements[i].partialSelected = true;
        if (expanded) {
          elements[i].expanded = true;
        }
        return el;
      }
    }
  }
}

export function showTooltip(event) {
  const target = event.target;
  if (target.title === undefined || !target.textContent) {
    return;
  }
  target.title = target.scrollWidth > target.clientWidth ? target.textContent : '';
}

export function toggleCollapse(node: any, isCollapsed: boolean) {

  if (node.children) {
    node.expanded = isCollapsed;
    for (const cn of node.children) {
      if (cn) {
        toggleCollapse(cn, isCollapsed);
      }
    }
  }
}

export function expandRubricsTree(roots, nodes) {
  nodes.forEach(node => {
    if (node.children && node.children.length !== 0) {
      expandRubricsTree(roots, node.children);
    }
    roots.push(node);
  });
}

export function synchonizeBreadcrumbs(data: any[], snapshot: any, field: string, breadcrumbs: any, obj?: string) {
  if (data && data.filter && snapshot.data) {
    const found = data.filter(_d => _d.id + '' === snapshot.data.id + '');
    if (found && found.length > 0) {
      snapshot.data = found[0];
      if (breadcrumbs) {
        breadcrumbs = JSON.parse(JSON.stringify(breadcrumbs));
        breadcrumbs[breadcrumbs.length - 1].label = obj ? snapshot.data[obj][field] : snapshot.data[field];
      }
    }
  }
  return breadcrumbs;
}

export function readLocalStorage(name: string, localStorageApi: any): (string | []) {
  const ls = localStorageApi.load(true, name);
  if (ls) {
    return JSON.parse(ls);
  }
  return undefined;
}


export function readSelected(href: string, data: any, cmp: string, ids: (string | string[])): [] {
  if (data && href && href.indexOf(cmp) !== -1) {
    if (ids && isArray(ids)) {
      return ((data as any[]).filter(d => ids.indexOf((d as any).id + '') !== -1) as []);
    } else if (ids) {
      return ((data as any[]).filter(d => ids === (d as any).id + '') as []);
    }
  }
  return [];
}
